<template>
  <div class="main-header">
    <div class="main-header_burger" @click="showMobileMenu">
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" focusable="false" class="chakra-icon main-header_burger_icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
          <path fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M80 160h352M80 256h352M80 352h352"></path>
        </svg>
    </div>

    <div v-if="$route.meta.parent">
      <default-button
          :class="'secondary-button'"
          button_small
          @click="$router.go(-1)">
        <
        {{ $t('main.back') }}
      </default-button>
    </div>
    <default-title h_tag="h2">{{$t("routes." + this.$route?.name) || get_route_name}}</default-title>
    <div class="main-header_user position-relative mr-10">
      <div class="d-flex align-center">
        <change-locale
          active_lang_darker
        />
        <div>
          <div
            class="main-header_user_logout"
            tabindex="0">
            <span class="main-header_user-badge">
               {{ get_user_first_characters}}
            </span>
<!--            <chevron-down-icon class="ml-5" fill="#000"/>-->
          </div>
          <div class="main-header_user_logout-block">
            <div class="user_info">
              {{ $t('main.hello') }}, <b>{{getUser.name || 'User'}}</b>
            </div>
            <hr class="my-0"/>
            <div class="mt-10" v-if="!getUserRoleIsNewUser">
              <router-link-to
                :route_name="route_names.profile">
                {{ $t('main.my_profile') }}
              </router-link-to>
            </div>
            <div class="logout-btn"
                 @click.stop="logoutUser">
              {{ $t('main.logout') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="getAdminImpersonateUser">
      <default-button
          button_small
          @click="unImpersonate(getAdminImpersonateUser)">
        {{ $t('main.back_to_my_account') }}
        <logout-icon/>
      </default-button>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import routes_mixin from "../../mixins/routes_mixin";
import NoUserIcon from "../icons/NoUserIcon";
import user_mixin from "../../mixins/user_mixin";
import ChevronDownIcon from "../icons/ChevronDownIcon";
import RouterLinkTo from "../small_components/RouterLinkTo";
import DefaultTitle from "../small_components/DefaultTitle";
import ChangeLocale from "../small_components/ChangeLocale";
import {axiosUsers} from "../../helpers/axios_requests";
import ROUTER, {GET_PARAMS_ROUTE_PARAMS, GO_TO_DASHBOARD, ROUTES_NAMES} from "../../router";
import DefaultButton from "../small_components/DefaultButton.vue";
import LogoutIcon from "../icons/LogoutIcon.vue";

export default {
  name: "HeaderBlock",
  mixins: [routes_mixin, user_mixin],
  components: {
    LogoutIcon, DefaultButton,
    ChangeLocale,
    DefaultTitle,
    RouterLinkTo,
    ChevronDownIcon,
    NoUserIcon,
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getAdminImpersonateUser',
      'getUserRoleIsNewUser'
    ]),
    get_route_name() {
      return this.$route?.meta?.title;
    },
    get_user_first_characters() {
      if (!this.getUser) return ''
      return `${(this.getUser.name || '').substring(0, 1)}${(this.getUser.surname || '').substring(0, 1)}`
    }
  },
  created() {

  },
  methods: {
    ...mapActions([
      'actionSetUser',
      'actionSetAdminImpersonateUser'
    ]),
    showMobileMenu() {
      this.$root.$emit('openAside')
    },
    unImpersonate(item) {
      axiosUsers.login_by_id({
        id: item.id,
      }).then(({data}) => {
        this.actionSetUser(data.user || null)
        this.actionSetAdminImpersonateUser(null)
        GO_TO_DASHBOARD()
      })
    },
    goTo(route_name) {
      ROUTER.push({
        name: route_name,
      })
    }
  }
}
</script>
